module.exports = __webpack_public_path__ + "static/media/circle_red.3ba18526.svg";